// extracted by mini-css-extract-plugin
export default {"numberAnimation":"numberAnimation-hwf01","lottie":"lottie-pSFH4","numberAnimationMobile":"numberAnimationMobile-bZG8Y","hide":"hide-_v0s2"};